import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col" }

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OptionsNowYouHaveAPlan',
  setup(__props) {

const store = useStore();
const display = ref(false);

onMounted(() => {
    display.value = store.state.configuration.finishDisplaysOptionsNowYouHaveAPlan;
});


return (_ctx: any,_cache: any) => {
  return (display.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SubSection, {
            title: "Options now you have built a plan",
            "show-help": false
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("p", null, " There are lots of ways we can help now you have built a plan. For those that don't want to pay for advice, we show some chosen low cost providers who may be suitable to put all your pots together with. For those that want to take advice we show some vetted advisers you can seek advice from. For those that want to buy some guaranteed income, we show some annuity brokers who can help get you the best deal. ", -1),
              _createElementVNode("p", null, " Some of our partners license our tech and we have commercial arrangements with them to do so, but we do not take any referral fees from them should you choose them. ", -1)
            ])),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})